module.exports = __webpack_public_path__ + "static/img/home-banner.22cea26.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home-banner.png
// module id = wDUo
// module chunks = 0